/**
 * Card — the single white surface used across the app (KPI tiles, list items,
 * panels, empty states). Replaces the hand-repeated
 *   `bg-white rounded-[16px] border` + inline borderColor + boxShadow
 * pattern with token-driven defaults (--r-xl, --border, --sh-1).
 *
 * Props:
 *   hover    — lift + raise shadow on hover (for interactive cards)
 *   padded   — apply default padding (16px). Set false for custom inner layout.
 *   as       — render as a different element/component (e.g. 'button', Link)
 */
export default function Card({
  hover = false,
  padded = true,
  as: Tag = 'div',
  className = '',
  style,
  children,
  ...rest
}) {
  return (
    <Tag
      className={[
        'bg-white border',
        padded ? 'p-4' : '',
        hover ? 'transition-all cs-card-hover' : '',
        className,
      ].filter(Boolean).join(' ')}
      style={{
        borderRadius: 'var(--r-xl)',
        borderColor: 'rgba(226,217,200,0.7)',
        boxShadow: 'var(--sh-1)',
        transitionDuration: hover ? 'var(--dur-slow)' : undefined,
        transitionTimingFunction: hover ? 'var(--ease-out)' : undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
